// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4c37a026","425":"c94c029f","510":"4df45a77","532":"414d80e7","633":"3eb47eb5","634":"75d7d397","922":"b3e1bd99","937":"9fe3eb23","972":"eea7ac7e"}[chunkId] + ".chunk.js";
};